import { Button, FormControl, Menu, MenuItem, Select, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  buttonStyle1,
  buttonStyle2,
} from '../../ChartAxes/CardComponents/ReusableStyles/ButtonStyles';
import {
  TSlidingAggregation,
  TSlidingStandingAggregation,
  TWindowFn,
  TwinFnOrder,
  TWinfnRank,
} from '../../../types/types';
import Standing from './Standing';
import { dropDownSelectStyle } from '../../ChartAxes/CardComponents/ReusableStyles/CommonStyles';
import { palette } from '../../..';
import Sliding from './Sliding';
import StandingVsSlicing from './StandingVsSlicing';
import { useDispatch } from 'react-redux';
import {
  AddOrUpdateWindowFunction,
  RemoveWindowFunction,
} from '../../../redux/Calculations/CalculationsActions';
interface FlowWindowFunctionProps {
  propKey: string;
  winfn?: TWindowFn;
  anchhorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
  flowId: string;
}
function FlowWindowFunction({
  anchhorEl,
  onClose,
  open,
  winfn,
  propKey,
  flowId,
}: FlowWindowFunctionProps) {
  const dispatch = useDispatch();

  const [selected, setSelected] = useState<'standing' | 'sliding' | 'standingsvssliding'>(
    'standing',
  );
  const dimensions = [
    '(Entire Table)',
    '1st Dimension',
    '2nd Dimension',
    '3rd Dimension',
    '4th Dimension',
    '5th Dimension',
    '6th Dimension',
    '7th Dimension',
    '8th Dimension',
  ];

  const [windowfn, setWindowFn] = useState<TWindowFn>(
    winfn ?? {
      windowFn: ['standing', 'default', 'ascending'],
      windowFnPartition: [-1, -1],
    },
  );
  const changeWindowFunctionType = (type: 'standing' | 'sliding' | 'standingsvssliding') => {
    setSelected(type);
    if (type === 'standing') {
      setWindowFn({
        windowFn: ['standing', 'default', 'ascending'],
        windowFnPartition: [-1, -1],
      });
    } else if (type === 'sliding') {
      setWindowFn({
        windowFn: ['sliding', 'sum'],
        windowFnPartition: [-1, -1, 0],
        windowFnOption: [-999, 0],
      });
    } else {
      setWindowFn({
        windowFn: ['percentageFrom', 'sum'],
        windowFnOption: [-1],
        windowFnPartition: [-1, -1, 0],
      });
    }
  };

  const handleDimensionChange = (type: 'row' | 'column', value: number) => {
    let partiton = windowfn.windowFnPartition;
    partiton[type === 'row' ? 0 : 1] = value;
    setWindowFn({ ...windowfn, windowFnPartition: partiton });
  };
  const updateWindowFunction = (
    optionType: 'standing' | 'sliding' | 'standingsvssliding',
    idx: number,
    value: string | number,
    type: string,
    agg?: TSlidingAggregation,
  ) => {
    if (optionType === 'standing') {
      if (['rank', 'order'].includes(type)) {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[idx] = value as string;
        setWindowFn({ ...windowfn, windowFn: updatedWindowFn });
      }
    } else if (optionType === 'sliding') {
      if (['aggregation'].includes(type)) {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[idx] = value as string;
        setWindowFn({ ...windowfn, windowFn: updatedWindowFn });
      } else if (['prev', 'current', 'next'].includes(type)) {
        const updatedWindowFnOption = windowfn.windowFnOption
          ? [...windowfn.windowFnOption]
          : [-999, 0];
        updatedWindowFnOption[idx] = value as number;
        if (
          type === 'current' &&
          updatedWindowFnOption[0] === 0 &&
          updatedWindowFnOption[1] === 0
        ) {
          updatedWindowFnOption[idx === 0 ? 1 : 0] = -999;
        }
        setWindowFn({ ...windowfn, windowFnOption: updatedWindowFnOption });
      } else if (type === 'default') {
        const updatedWindowFnOption = windowfn.windowFnOption
          ? [...windowfn.windowFnOption]
          : [-999, 0];
        updatedWindowFnOption[0] = -999;
        updatedWindowFnOption[1] = 0;
        setWindowFn({ ...windowfn, windowFnOption: updatedWindowFnOption });
      } else if (type === 'trim') {
        const updatedWindowFnOption = windowfn.windowFnOption
          ? [...windowfn.windowFnOption]
          : [-999];
        updatedWindowFnOption.splice(1, 1);
        setWindowFn({ ...windowfn, windowFnOption: updatedWindowFnOption });
      } else if (type === 'direction') {
        const updatedWindowFnOption = windowfn.windowFnPartition
          ? [...windowfn.windowFnPartition]
          : [-1, 1, 1];
        updatedWindowFnOption[2] = value as number;
        setWindowFn({ ...windowfn, windowFnPartition: updatedWindowFnOption });
      }
    } else {
      /** else part is for standingVsSliding */
      /** type === 'percentage'
       * means percentageFrom, differenceFrom, percentageDifferenceFrom
       ******/
      /** type === 'referenceWn'
       * means first, last, pnc(previous,next,current)
       *
       */

      if (type === 'percentage') {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[idx] = value as string;
        setWindowFn({ ...windowfn, windowFn: updatedWindowFn });
      } else if (type === 'changePrevNextDropDown') {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[1] = agg ?? 'sum';
        const updatedWindowFnOption = windowfn.windowFnOption
          ? [...windowfn.windowFnOption]
          : [-999, 0];
        updatedWindowFnOption[idx] = value as number;
        if (updatedWindowFnOption[0] === 0 && updatedWindowFnOption[1] === 0) {
          updatedWindowFnOption[idx === 0 ? 1 : 0] = -999;
        }
        setWindowFn({
          ...windowfn,
          windowFn: updatedWindowFn,
          windowFnOption: updatedWindowFnOption,
        });
      } else if (type === 'trim') {
        const updatedWindowFnOption = windowfn.windowFnOption
          ? [...windowfn.windowFnOption]
          : [-999];
        updatedWindowFnOption.splice(1, 1);
        setWindowFn({ ...windowfn, windowFnOption: updatedWindowFnOption });
      } else if (type === 'default') {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[1] = 'sum';
        const { windowFnOption = [], ...rest } = windowfn;
        windowFnOption[0] = -1;
        windowFnOption.splice(1, 1);
        setWindowFn({ ...rest, windowFn: updatedWindowFn, windowFnOption: windowFnOption });
      } else if (
        type === 'referenceWn' &&
        (['first', 'last'].includes(value as string) || value === 'pnc')
      ) {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[idx] = value === 'pnc' ? (agg ?? 'sum') : (value as string);
        setWindowFn({ ...windowfn, windowFn: updatedWindowFn });
      } else if (['prev', 'current', 'next'].includes(type)) {
        const updatedWindowFnOption = windowfn.windowFnOption
          ? [...windowfn.windowFnOption]
          : [-999, 0];
        updatedWindowFnOption[idx] = value as number;
        if (type === 'current') {
          updatedWindowFnOption[idx === 0 ? 1 : 0] = -999;
        }
        setWindowFn({ ...windowfn, windowFnOption: updatedWindowFnOption });
      } else if (type === 'aggregation' && !['first', 'last'].includes(windowfn.windowFn[1])) {
        const updatedWindowFn = [...windowfn.windowFn];
        updatedWindowFn[idx] = value as string;
        setWindowFn({ ...windowfn, windowFn: updatedWindowFn });
      } else if (type === 'direction') {
        const updatedWindowFnOption = windowfn.windowFnPartition
          ? [...windowfn.windowFnPartition]
          : [-1, 1, 0];
        updatedWindowFnOption[2] = value as number;
        setWindowFn({ ...windowfn, windowFnPartition: updatedWindowFnOption });
      }
    }
  };
  const handleSave = () => {
    onClose();
    dispatch(AddOrUpdateWindowFunction(propKey, flowId, windowfn));
  };
  const handleRemove = () => {
    onClose();
    dispatch(RemoveWindowFunction(propKey, flowId));
  };

  useEffect(() => {
    if (winfn) {
      setWindowFn(winfn);
      const selectedType = winfn.windowFn[0];
      if (['standing', 'sliding'].includes(selectedType))
        setSelected(selectedType as 'standing' | 'sliding' | 'standingsvssliding');
      else setSelected('standingsvssliding');
    } else {
      setWindowFn({ windowFn: ['standing', 'default', 'ascending'], windowFnPartition: [-1, -1] });
      setSelected('standing');
    }
  }, [winfn]);
  return (
    <Menu
      anchorEl={anchhorEl}
      open={open}
      onClose={onClose}
      onDoubleClick={(e) => {
        e.stopPropagation();
      }}
      sx={{
        '.MuiPaper-root': {
          width: '222px',
          maxHeight: 'none',
          overflow: 'visible',
        },
      }}
    >
      <div className="buttons">
        <div className="standingBtn">
          <Button
            variant="contained"
            color="inherit"
            size="small"
            sx={selected === 'standing' ? buttonStyle1 : buttonStyle2}
            onClick={() => changeWindowFunctionType('standing')}
          >
            Standing
          </Button>
        </div>
        <div className="standingslidingBtn">
          <Button
            variant="contained"
            color="inherit"
            size="small"
            sx={selected === 'sliding' ? buttonStyle1 : buttonStyle2}
            onClick={() => changeWindowFunctionType('sliding')}
          >
            Sliding
          </Button>
        </div>
        <div className="standingslidingBtn">
          <Button
            variant="contained"
            color="inherit"
            size="small"
            onClick={() => changeWindowFunctionType('standingsvssliding')}
            sx={selected === 'standingsvssliding' ? buttonStyle1 : buttonStyle2}
          >
            Standing vs Sliding
          </Button>
        </div>
      </div>
      {selected === 'standing' && (
        <Standing
          rank={windowfn.windowFn[1] as TWinfnRank}
          order={windowfn.windowFn[2] as TwinFnOrder}
          onChange={updateWindowFunction}
        />
      )}
      {selected === 'sliding' && windowfn.windowFnOption && (
        <Sliding
          prev={windowfn.windowFnOption[0] ?? -999}
          next={windowfn.windowFnOption[1]}
          // current={windowfn.windowFnOption[1] ?? 1}
          aggregation={(windowfn.windowFn[1] ?? 'sum') as TSlidingAggregation}
          onChange={updateWindowFunction}
        />
      )}
      {selected === 'standingsvssliding' && (
        <StandingVsSlicing
          percentage={
            windowfn.windowFn[0] as 'percentageFrom' | 'differenceFrom' | 'percentageDifferenceFrom'
          }
          isFirst={windowfn.windowFn[1] === 'first'}
          isPNC={!['last', 'first'].includes(windowfn.windowFn[1])}
          isCurrent={windowfn.windowFnOption ? windowfn.windowFnOption[1] === 1 : true}
          isLast={windowfn.windowFn[1] === 'last'}
          aggregation={windowfn.windowFn[1] as TSlidingStandingAggregation}
          prev={windowfn.windowFnOption ? windowfn.windowFnOption[0] : undefined}
          next={windowfn.windowFnOption ? windowfn.windowFnOption[1] : undefined}
          onChange={updateWindowFunction}
        />
      )}
      <div>
        <Typography
          sx={{
            fontSize: '12px',
            paddingLeft: '15px',
            fontWeight: '600',
            color: 'rgb(96, 96, 96)',
            marginTop: '5px',
          }}
        >
          per Row
        </Typography>

        <FormControl fullWidth>
          <Select
            sx={{ ...dropDownSelectStyle, margin: '3px 15px 0 15px' }}
            onChange={(e) => handleDimensionChange('row', e.target.value as number)}
            value={windowfn.windowFnPartition[0]}
          >
            {dimensions.map((dim, index) => (
              <MenuItem
                key={index}
                value={dim === '(Entire Table)' ? -1 : index - 1}
                sx={{ fontSize: '12px', padding: '2px 1rem' }}
              >
                {dim}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div>
        <Typography
          sx={{
            fontSize: '12px',
            paddingLeft: '15px',
            fontWeight: '600',
            color: 'rgb(96, 96, 96)',
            marginTop: '12px',
          }}
        >
          per Column
        </Typography>

        <FormControl fullWidth>
          <Select
            value={windowfn.windowFnPartition[1]}
            sx={{ ...dropDownSelectStyle, margin: '3px 15px 0 15px' }}
            onChange={(e) => handleDimensionChange('column', e.target.value as number)}
          >
            {dimensions.map((dim, index) => (
              <MenuItem
                key={index}
                value={dim === '(Entire Table)' ? -1 : index - 1}
                sx={{ fontSize: '12px', padding: '2px 1rem' }}
              >
                {dim}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {['sliding', 'standingsvssliding'].includes(selected) && (
        <div>
          <Typography
            sx={{
              fontSize: '12px',
              paddingLeft: '15px',
              fontWeight: '600',
              color: 'rgb(96, 96, 96)',
              marginTop: '12px',
            }}
          >
            Slide Direction
          </Typography>

          {/* {isEmptyAxes ? (
                <div className="commonOption2">
                <div
                    style={{
                    borderRadius: "2px 0 0 2px",
                    margin: "3px 0 0 15px",
                    color: "rgba(0, 0, 0, 0.38)",
                    }}
                    className={
                    windowFnValues.windowFnOptions === "sliding" &&
                    windowFnValues.slidingSlideDirection === "rowwise"
                        ? "slideDirectionSelected"
                        : windowFnValues.windowFnOptions ===
                            "standingsvssliding" &&
                        windowFnValues.standingSlidingSlideDirection ===
                            "rowwise"
                        ? "slideDirectionSelected"
                        : "slideDirection"
                    }
                >
                    Row wise
                </div>
        
                <div
                    style={{
                    borderRadius: "0 2px 2px 0",
                    margin: "3px 15px 0 0",
                    color: "rgba(0, 0, 0, 0.38)",
                    }}
                    className={
                    windowFnValues.windowFnOptions === "sliding" &&
                    windowFnValues.slidingSlideDirection === "columnwise"
                        ? "slideDirectionSelected"
                        : windowFnValues.windowFnOptions ===
                            "standingsvssliding" &&
                        windowFnValues.standingSlidingSlideDirection ===
                            "columnwise"
                        ? "slideDirectionSelected"
                        : "slideDirection"
                    }
                >
                    Column wise
                </div>
                </div>
            ) : ( */}
          <div className="commonOption2">
            <div
              onClick={() => updateWindowFunction(selected, 2, 0, 'direction')}
              style={{
                borderRadius: '2px 0 0 2px',
                margin: '3px 0 0 15px',
              }}
              className={
                windowfn.windowFnPartition[2] === 0 ? 'slideDirectionSelected' : 'slideDirection'
              }
            >
              Row wise
            </div>

            <div
              onClick={() => updateWindowFunction(selected, 2, 1, 'direction')}
              style={{
                borderRadius: '0 2px 2px 0',
                margin: '3px 15px 0 0',
              }}
              className={
                windowfn.windowFnPartition?.[2] === 1 ? 'slideDirectionSelected' : 'slideDirection'
              }
            >
              Column wise
            </div>
          </div>
          {/* )
            } */}
        </div>
      )}
      <div
        className="cancelOkBtn"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingInline: '15px',
          marginBlock: '1rem',
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          sx={{
            fontSize: '10px',
            boxShadow: 'none',
            border: '2px solid gray',
            color: 'gray',
            borderRadius: '2px',
            textTransform: 'initial',
            '&:hover': {
              color: 'white',
              backgroundColor: 'red',
              border: '2px solid red',
              boxShadow: '0px 0px 2px 1px red',
            },
          }}
          onClick={handleRemove}
        >
          Remove
        </Button>

        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={handleSave}
          sx={{
            fontSize: '10px',
            boxShadow: 'none',
            border: `2px solid ${palette.primary.main}`,
            borderRadius: '1px',
            textTransform: 'initial',
            color: palette.primary.main,
            '&:hover': {
              color: 'white',
              backgroundColor: palette.primary.main,
              boxShadow: `0px 0px 2px 1px ${palette.primary.main}`,
            },
          }}
        >
          Save
        </Button>
      </div>
    </Menu>
  );
}

export default FlowWindowFunction;
